import { Injectable, Inject, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { catchError, finalize, tap, exhaustMap, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TableService, TableResponseModel, ITableState, BaseModel, PaginatorState, SortState, GroupingState } from '../../_metronic/shared/crud-table';
import { HomeSlide } from '../_models/homeslide.model';
import { baseFilter } from '../../_fake/fake-helpers/http-extenstions';
import { first } from 'rxjs/operators';
import { AuthService } from '../../modules/auth/_services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class HomePageService extends TableService<Document> implements OnDestroy {
  httpHeaders : any;

  apiUrls = {
    getSlides : `${environment.url}/${environment.apiUrl}/Producer/get_slides`,
    getTotalesRamos : `${environment.url}/${environment.apiUrl}/Producer/get_totales_por_ramo?`,
    getDetalleRamo : `${environment.url}/${environment.apiUrl}/Producer/get_detalle_por_ramo?`,
  }

  constructor(@Inject(HttpClient) http, private auth: AuthService) {
    super(http);
  }

  // READ
  async getSlides(paramsGet: string = "") {
    var response = await this.http.get<HomeSlide>(this.apiUrls.getSlides + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
    if(typeof response != 'undefined') {
      return response;
    }
  }

  async getTotalesRamos(paramsGet: string = "") {
    var response = await this.http.get<Document>(this.apiUrls.getTotalesRamos + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
    if(typeof response != 'undefined') {
      return response;
    }
  }

  async getDetalleRamo(paramsGet: string = "") {
    var response = await this.http.get<Document>(this.apiUrls.getDetalleRamo + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
    if(typeof response != 'undefined') {
      return response;
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }
}